<template>
    <div id="VendorView">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div class="web-right-sidebar" v-if="displayMenu">
            <div class="right-asset-tab-list">
                <ul id="tabActive" class="activetabs">
                    <li v-bind:class="[ activetab === 1 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 1"> Vendor Detail </a> </li>
                    <!--<li v-bind:class="[ activetab === 2 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 2">Contact Details</a> </li>-->
                    <!-- <li v-bind:class="[ activetab === 3 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="activetab = 3">Classification</a> </li> -->
                    <li v-bind:class="[ activetab === 5 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click.prevent="vendorCRM()">CRM</a> </li>
                    <li v-bind:class="[ activetab === 4 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click.prevent="loadVendorGL()">General Ledger</a> </li>
                    <li v-bind:class="[ activetab === 6 ? 'active' : '' ]"> <a href="javascript:void(0)" v-on:click="getActivityLog()"> Activity Log </a> </li>
                </ul>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name" v-if="name">
                    <div class="page-title"> {{ name }} ({{ code }})</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <router-link title="Edit Asset" class="btn btn-primary" v-if="activetab == 1"
                            v-bind:to="{name: 'VendorEdit',params:{id:$route.params.id}}">
                            <i class="fp-edit-icon"> </i> Edit
                        </router-link>
                        <button type="submit" class="btn btn-secondary pull-right ml-1" v-on:click.prevent="goPreviousPath" >
                             <i class="fp-back"> </i>    Back
                        </button>
                    </div>
                </div>
                <div class="container-fluid">
                    <!-- Vendor Details -->
                    <div id="vendor-detail" class="admin-page-content vendor-view list-view" v-show="activetab == 1">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Code:</label>
                                        <span class="col"> {{titleCase(vendorData.vendor_code)}} </span>
                                    </div>
                                    <div class="row form-group" v-if="vendorData.federal_tax_eligible == 0">
                                        <label class="col"> Vendor 1099 Eligible?:</label>
                                        <span class="col"> {{ "No" }} </span>
                                    </div>
                                    <div class="row form-group" v-else>
                                        <label class="col"> Vendor 1099 Eligible?: </label>
                                        <span class="col"> {{ "Yes" }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col"> Federal Employer Identification Number:</label>
                                        <span class="col"> {{titleCase(vendorData.fein)}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Address Line 1:</label>
                                        <span class="col"> {{titleCase(vendorData.address_1)}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">State:</label>
                                        <span class="col"> {{titleCase(vendorData.stateName)}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Zip:</label>
                                        <span class="col"> {{titleCase(vendorData.zip)}} </span>
                                    </div>
                                    <template v-if="vendorData.po_required == 1">
                                        <div class="row form-group">
                                            <label class="col">PO Required:</label>
                                            <span class="col"> Yes </span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="row form-group">
                                            <label class="col">PO Required:</label>
                                            <span class="col"> No </span>
                                        </div>
                                    </template>
                                     <div class="row form-group">
                                        <label class="col">Payment Type:</label>
                                        <span class="col"> {{vendorData.payment_type}} </span>
                                    </div>
                                    <template v-if="vendorData.one_time_vendor == 1">
                                        <div class="row form-group">
                                            <label class="col">One Time Vendor:</label>
                                            <span class="col"> Yes </span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="row form-group">
                                            <label class="col">One Time Vendor:</label>
                                            <span class="col"> No </span>
                                        </div>
                                    </template>
                                    
                                    <div class="row form-group">
                                        <label class="col">Vendor Invoice Required?:</label>
                                        <span class="col" v-if="vendorData.required_attachment == 1"> Yes </span>
                                        <span class="col" v-else> No </span>
                                    </div>
                                    
                                    <template v-if="vendorData.financier_vendor == 1">
                                        <template v-if="financier_gl != ''">
                                            <div class="row form-group">
                                                <label class="col">Financier GL Account:</label>
                                                <span class="col"> {{financier_gl}} </span>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col"> Name: </label>
                                        <span class="col"> {{titleCase(vendorData.name)}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col"> Tax Type: </label>
                                        <span class="col"> {{titleCase(vendorData.vendor_tax_name)}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col"> Website: </label>
                                        <span class="col"> {{vendorData.website}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col"> Address Line 2: </label>
                                        <span class="col"> {{titleCase(vendorData.address_2)}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col"> City: </label>
                                        <span class="col"> {{titleCase(vendorData.cityName)}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col"> Phone No: </label>
                                        <span class="col"> {{titleCase(vendorData.phone)}} </span>
                                    </div>
                                    <template v-if="vendorData.seperate_cheque == 1">
                                        <div class="row form-group">
                                            <label class="col">Seperate Cheque:</label>
                                            <span class="col"> Yes </span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="row form-group">
                                            <label class="col">Seperate Cheque:</label>
                                            <span class="col"> No </span>
                                        </div>
                                    </template>
                                    <template v-if="vendorData.monthly_payable == 1">
                                        <div class="row form-group">
                                            <label class="col">Monthly Payable:</label>
                                            <span class="col"> Yes </span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="row form-group">
                                            <label class="col">Monthly Payable:</label>
                                            <span class="col"> No </span>
                                        </div>
                                    </template>
                                    <template v-if="vendorData.financier_vendor == 1">
                                        <div class="row form-group">
                                            <label class="col">Financier:</label>
                                            <span class="col"> Yes </span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="row form-group">
                                            <label class="col">Financier:</label>
                                            <span class="col"> No </span>
                                        </div>
                                    </template>
                                    <div class="row form-group">
                                        <label class="col">Assignee:</label>
                                        <span class="col"> {{vendorData.assignee}} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Term:</label>
                                        <span class="col"> {{termVal}} </span>
                                    </div>
                                </div>
                            </div>
                            <h6 class="color-blue font-bold mt-3 pl-2">Contact Details</h6>
                            <div class="form-row no-divider">
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col"> Name </label>
                                    <span class="col">{{titleCase(vendorData.contact_name)}} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col"> Phone: </label>
                                    <span class="col"> {{ vendorData.contact_phone }} </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Email:</label>
                                    <span class="col"> {{ vendorData.contact_email }} </span>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="internal-container border-top-table-fl mt-4">
                        <h5> Attachments </h5>
                        <div class="attachment-view-internal-section">
                            <template v-if="files && files.length > 0">
                                <template v-for="(doc,vkey) in files">
                                    <div v-bind:key="'fileDiv'+vkey" class="attachment-list mt-2">
                                        <i v-if="doc.ext == 'pdf'" class="fp-pdf-icon"></i>
                                        <i v-if="doc.ext == 'doc' || doc.ext == 'docs'" class="fp-text-document"></i>
                                        <i v-if="doc.ext == 'jpg' ||  doc.ext == 'png' ||  doc.ext == 'jpeg' " class="fp-image"></i>
                                        <a :key="vkey" href="javascript:void(0)" class="customer-detail-rv" v-on:click="openDocument(doc.url,doc.ext)">  {{doc.display_name}}</a>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <button type="button"  v-bind:key="'cancelBtn'+vkey" v-on:click="deleteVendorFile(vkey,doc.path);">
                                            <i class="fp-remove"></i>
                                        </button>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <span>No attachments found.</span>
                            </template>
                        </div>
                    </div>
                </div>
                    <!-- <div id="vendor-detail" class="admin-page-content" v-show="activetab == 3">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <div class="col-md-12 customer-view-main">
                                    <div class="row">
                                        <ul>
                                            <template v-if="classificationArr.length > 0">
                                                <template v-for="(classification,classKey) in classificationArr">
                                                    <li :key="classKey">
                                                        {{classification.text}}
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <li>No Classification Found.</li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div> -->

                    <div id="vendor-gl-list" class="admin-page-content vendor-view list-view" v-show="activetab == 4">
                        <div class="bg-white data-table p-0">
                            <app-module-gl v-if="vendorGLLoad" :moduleName="'vendor'" :moduleId="vendor_id"></app-module-gl>
                        </div>
                    </div>

                    <div id="vendor-crm-list" class="admin-page-content vendor-view list-view" v-show="activetab == 5">
                        <template v-if="crmAdd">
                            <crm-create :fromModule="vendorObj"></crm-create>
                        </template>
                        <template v-else>
                            <button v-if="canAddCrm" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="addCrm"><i class="fp-add"> </i>Add</button>
                            <section class="internal-container border-top-table-fl" style="margin-top:40px !important;">
                                <div class="bg-white data-table p-0">
                                    <vendor-crm-list v-if="enableVendorCrm" :moduleVal="'vendor'" :moduleId="vendor_id"></vendor-crm-list>
                                </div>
                            </section>
                        </template>
                    </div>

                    <div id="vendor-activity-log" class="list-view" v-show="activetab == 6">
                        <div class="bg-white data-table p-0">
                            <vendor-activity-log-list :activityLogVal="activityLogsTabValue"></vendor-activity-log-list>
                        </div>
                    </div>

                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
//import VendorTabView from "@/components/VendorTabView";
import {commonMixins} from '../mixins/commonMixins';

import CrmCreate from "@/components/CrmCreate.vue";
import appModuleGL from "@/components/ModuleWiseGLList";


Vue.component("crm-create", CrmCreate);
Vue.component("app-module-gl", appModuleGL);
//Vue.component("app-vendor-tab", VendorTabView);
    export default {
        name: "VendorView",
        // metaInfo: {
        //     // title will be injected into parent titleTemplate
        //     title: "Vendor View  | " +process.env.COPYRIGHT_NAME
        // },
        components: {
            
            VendorCrmList: () => import('@/components/CrmList.vue'),
            VendorActivityLogList: () => import('@/components/ActivityLogList.vue'),
        },
        mixins:[commonMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            vendorData: [],
            loading:false,
            activetab: 1,
            journalsArr:[],
            displayMenu:false,
            code:'',
            name:'',
            classificationArr:[],
            canListVendor:false,
            pageKey:"",
            files:[],
            vendor_id:"",
            enableVendorCrm:false,
            canAddCrm:false,
            crmAdd:false,
            vendorObj:{},
            financier_gl:"",
            loadingGL:false,
            vendorGLLoad:false,
            termVal:"",
            activityLogsTabValue:"dontLoadList",
            tabMenuArray:[],
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_vendor') {
                            self.cantAccessPage = true;
                            self.displayMenu = true;
                        }
                        if (permissions[i].name == 'list_vendor') {
                            self.canListVendor = true;
                        }
                        if (permissions[i].name == 'add_crm') {
                            self.canAddCrm = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            self.loadContract();
            var pathUrl = window.location.pathname;
            var segments = pathUrl.split("/");
            self.pageKey='_vendor_view_'+segments[3];
            //set value in vendor object for crm
            self.vendor_id = segments[3];
            self.vendorObj.module = "vendor";
            self.vendorObj.vendor_id = segments[3];
            self.vendorObj.flag = "add";
            self.vendorObj.crm_id = "";
        },
        metaInfo() {
            return {
                title: (this.code != "") ? this.code + " | Vendor View | " +process.env.COPYRIGHT_NAME:"Vendor View | " +process.env.COPYRIGHT_NAME
            }
        },
        methods: {

            handleClick(newTab) {

                var self = this;
                self.currentTab = newTab;
            },

            selectTab(flag){

                alert("You are select " + flag);

            },

            loadContract() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/vendor/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.code = data.content.vendor_code;
                            var storeObject={visited_page: {
                                    path : "Accounting-vendor-view |" +data.content.vendor_code,
                                    data : window.location.pathname,
                                    }};
                             self.getRecentlyPagesMethod(storeObject);
                            self.name = data.content.name;
                            self.vendorData = data.content;
                            if (data.content.journals != undefined) {
                                self.journalsArr = data.content.journals;
                            }else{
                                self.journalsArr = [];
                            }
                            if (data.content.classification != undefined) {
                                self.classificationArr = data.content.classification;
                            }else{
                                self.classificationArr = [];
                            }
                            if(data.content.docs != undefined && data.content.docs != null){
                                self.files = data.content.docs;
                            }
                            if(data.content.financier_gl_account != undefined && data.content.financier_gl_account != null){
                                self.financier_gl = self.ucString(data.content.glCode + " | " + data.content.glDesc);
                            }
                            if (data.content.termCode != undefined && data.content.termCode != null && data.content.termCode != "") {
                                self.termVal = data.content.termCode;
                                if (data.content.termName != undefined && data.content.termName != null && data.content.termName != "") {
                                    self.termVal += " | ";
                                    self.termVal += data.content.termName;
                                }
                            }else{
                                self.termVal = "-";
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'vendor-view');
                    }
                });
            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            deleteVendorFile(key,file) {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (confirm('Are you sure that you want to remove file? ')) {

                        if(segments[3] && segments[3] != undefined){

                            self.loading = true;

                            $.ajax({
                                url: process.env.ROOT_API + "/remove-vendor-file",
                                type: "POST",
                                crossDomain: true,
                                dataType: "json",
                                headers: this.ajxHeaders,
                                data: {
                                    id:segments[3],
                                    doc_path:file
                                },
                                success: function(data) {
                                    self.loading = false;
                                    if (data.status == "success") {

                                        self.loadContract();
                                        self.files = [];
                                    }
                                },
                                error: function(jqXHR, exception) {
                                    self.loading = false;
                                    self.files.splice(key,1);
                                    self.generateStatusCodeMessage(jqXHR,true,'vendor-doc-remove');
                                }
                            });

                        } else{

                            self.files.splice(key,1);

                        }
                    }
            },
            vendorCRM(){
                var self = this;
                self.activetab = 5;
                self.enableVendorCrm = true;
                if(!self.tabMenuArray.includes(self.activetab)){
                    self.tabMenuArray.push(self.activetab);
                }
            },
            addCrm() {
                var self = this;
                self.crmAdd = true;
                self.vendorObj.crm_id = "";
                self.vendorObj.flag = "add";
            },
            cancelCrmFromView() {
                var self = this;
                self.crmAdd = false;
            },
            editCrmFromView(crmId){
                var self = this;
                self.crmAdd = true;
                self.vendorObj.crm_id = crmId;
                self.vendorObj.flag = "update";
            },
            loadVendorGL() {
                var self = this;
                self.activetab = 4;
                self.vendorGLLoad = true;
                /*var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    name:"vendor",
                    id:segments[3],
                    doc_no:""
                };
                self.loadingGL = true;
                $.ajax({
                    url:process.env.ROOT_API + "/module/gl",
                    type:"POST",
                    data:fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loadingGL = false;
                        if (data.status == "success"){
                            self.journalsArr = data.content;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loadingGL = false;
                        self.generateStatusCodeMessage(jqXHR,true,'bill-gl')
                    }
                });*/
            },
            getActivityLog(){
              var self = this;
              self.activetab = 6;
              var path = window.location.pathname;
              var segments = path.split("/");
              if(!self.tabMenuArray.includes(self.activetab)){

                this.$root.$emit('activity_log_opted','vendor',segments[3]);
                self.activityLogsTabValue = "loadList";   // flag value set to loadList so that filters in list work properly.
              }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/VendorView.vue